import { CheckCircle2 } from 'lucide-react';

interface ComplianceMatrixProps {
    contract: any;
}

export function ComplianceMatrix({ contract }: ComplianceMatrixProps) {
    return (
        <div className="bg-[#0A0A0A]/50 backdrop-blur-sm p-8 rounded-3xl border border-white/5">
            <div className="flex items-center gap-3 mb-6">
                <div className="p-2 bg-green-500/10 rounded-lg">
                    <CheckCircle2 className="w-5 h-5 text-green-400" />
                </div>
                <h2 className="text-xl font-bold text-white tracking-tight">Compliance Matrix</h2>
            </div>

            <div className="space-y-3">
                <div className="group p-5 bg-black/20 hover:bg-black/40 rounded-xl transition-all duration-300 border border-white/5">
                    <div className="flex justify-between items-start mb-1">
                        <h3 className="font-bold text-gray-200 text-sm group-hover:text-blue-400 transition-colors">NAICS Code Match</h3>
                        <CheckCircle2 className="w-4 h-4 text-green-500" />
                    </div>
                    <p className="text-xs text-gray-500">Code {contract?.naicsCode} matches your core competency profile.</p>
                </div>
                {/* Additional generic compliance items could go here */}
            </div>
        </div>
    );
}
